import React from 'react';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import { URL_IMAGES_I } from '../../../../constants/UrlConstants';
import promoColors from '../../../../theme/promoColors';
import promoMedia from '../../../../theme/promoMedia';

const Container = styled.a`
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    background: ${(props) => (props.esLang ? 'transparent' : props.isInverted ? promoColors.white : promoColors.baseColor)};
    border-radius: 8px;
    width: ${(props) => (props.esLang ? 'auto' : '136px')};
    height: 40px;

    &:focus-visible {
        background-color: ${promoColors.gray80};
        outline: 1px dashed ${promoColors.baseColor};
    }

    ${promoMedia.desktop1440} {
        width: ${(props) => (props.esLang ? 'auto' : '208px')};
        height: 56px;
    }
`;
const AppImg = styled.img`
    width: ${(props) => (props.esLang ? 'auto' : '110px')};
    height: ${(props) => (props.esLang ? '40px' : '32px')};

    ${promoMedia.desktop1440} {
        width: ${(props) => (props.esLang ? 'auto' : '160px')};
        height: ${(props) => (props.esLang ? '56px' : '44px')};
    }
`;

export const AppButton = (props) => {
    const getImgLink = (props) => {
        if (props.variant === 'apple') {
            return props.esLang ? 'store-apple-inverted-es.svg' : props.isInverted ? 'store-apple-inverted.svg' : 'store-apple.svg';
        } else if (props.variant === 'google') {
            return props.esLang ? 'store-google-inverted-es.svg' : props.isInverted ? 'store-google-inverted.svg' : 'store-google.svg';
        } else if (props.variant === 'huawei') {
            return props.isInverted ? 'store-huawei-inverted.svg' : 'store-huawei.svg';
        }
    };
    return (
        <Container
            href={props.href}
            variant={props.variant}
            rel="noreferrer"
            target="_blank"
            aria-label={props.areaLabel}
            isInverted={props.isInverted}
            esLang={props.esLang}
            tabIndex={'0'}
        >
            <AppImg src={`${URL_IMAGES_I}/${getImgLink(props)}`} loading="lazy" decoding="async" alt={props.areaLabel} esLang={props.esLang} />
        </Container>
    );
};

AppButton.propTypes = {
    href: PropTypes.string,
    variant: PropTypes.oneOf(['apple', 'google', 'huawei']),
    areaLabel: PropTypes.oneOf(['App Store', 'Google Play', 'AppGallery']),
    isInverted: PropTypes.bool,
    esLang: PropTypes.bool,
};
